var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.333 6.667C2.6 6.667 2 7.266 2 8s.6 1.333 1.333 1.333c.734 0 1.334-.6 1.334-1.333 0-.734-.6-1.333-1.334-1.333zm9.334 0c-.734 0-1.334.6-1.334 1.333s.6 1.333 1.334 1.333C13.4 9.333 14 8.733 14 8c0-.734-.6-1.333-1.333-1.333zM8 6.667c-.733 0-1.333.6-1.333 1.333S7.267 9.333 8 9.333 9.333 8.733 9.333 8c0-.734-.6-1.333-1.333-1.333z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/_/_/shared/side-nav/src/assets/three-dots.svg";
export { SvgThreeDots as ReactComponent };